import { getSpriteUrl } from '../../getSpriteUrl';
import type { WalletBookSchema } from '../../legacyWalletBook.types';
import type { WalletConnectCatalogGroup } from '../getWalletConnectCatalog.types';

type TransformGroupParams = {
  group: WalletBookSchema['groups'][string];
};

/**
 * Transforms a wallet group schema into a WalletConnect catalog group.
 */
export const transformGroup = ({
  group,
}: TransformGroupParams): WalletConnectCatalogGroup => {
  const spriteId = group.brand?.spriteId ?? '';

  return {
    key: group.key,
    name: group.name,
    primaryColor: group.brand?.primaryColor,
    spriteUrl: spriteId ? getSpriteUrl({ spriteId }) : '',
  };
};
